var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4104 0.330969C14.9669 -0.110323 14.3017 -0.110323 13.8583 0.330969L8.09342 6.28842L2.32856 0.330969C1.88511 -0.110323 1.21993 -0.110323 0.776481 0.330969C0.333031 0.772262 0.333031 1.4342 0.776481 1.87549L6.54134 7.83294L0.554756 13.7904C0.111305 14.2317 0.111305 14.8936 0.554756 15.3349C0.776481 15.5556 0.998207 15.5556 1.21993 15.5556C1.44166 15.5556 1.88511 15.5556 1.88511 15.3349L7.64997 9.37746L13.4148 15.3349C13.6366 15.5556 13.8583 15.5556 14.08 15.5556C14.3017 15.5556 14.5235 15.5556 14.7452 15.3349C15.1886 14.8936 15.1886 14.2317 14.7452 13.7904L9.6455 7.83294L15.6321 1.87549C15.8538 1.4342 15.8538 0.772262 15.4104 0.330969Z",
    fill: "#E64B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clearIcon.b29885cc75964872b9dbdc82783de6e9.svg";
export { ForwardRef as ReactComponent };